import React from 'react';
import NHLECountyFilter from './filters/NHLECountyFilter';
import NHLEDistrictUABoroughFilter from './filters/NHLEDistrictUABoroughFilter';
import NHLEParishFilter from './filters/NHLEParishFilter';
import NHLEGradeFilter from './filters/NHLEGradeFilter';
import NHLEHeritageCategoriesFilter from './filters/NHLEHeritageCategoriesFilter';
import NHLEAssetTypeFilter from './filters/NHLEAssetTypeFilter';
import NHLEHistoricPeriodSelectFilter from './filters/NHLEHistoricPeriodSelectFilter';
import NHLEHistoricPeriodDateRangeFilter from './filters/NHLEHistoricPeriodDateRangeFilter';
import NHLEDocumentDateFilter from './filters/NHLEDocumentDateFilter';
import NHLEAssociatedPersonFilter from './filters/NHLEAssociatedPersonFilter';
import NHLEParliamentaryConstituencyFilter from './filters/NHLEParliamentaryConstituencyFilter';
import NHLECommentsAndPhotosFilter from './filters/NHLECommentsAndPhotosFilter';
import FormGroup from '../../components/FormGroup';

export default function NHLESearchFilters() {
  return (
    <>
      <FormGroup title="Heritage category / grade">
        <NHLEHeritageCategoriesFilter />
        <NHLEGradeFilter />
      </FormGroup>

      <FormGroup title="Location">
        <NHLECountyFilter />
        <NHLEDistrictUABoroughFilter />
        <NHLEParishFilter />
        <NHLEParliamentaryConstituencyFilter />
      </FormGroup>

      <FormGroup title="Asset type / associated person">
        <NHLEAssetTypeFilter />
        <NHLEAssociatedPersonFilter />
      </FormGroup>

      <FormGroup title="Dates">
        <NHLEHistoricPeriodSelectFilter />
        <NHLEHistoricPeriodDateRangeFilter />
        <NHLEDocumentDateFilter />
      </FormGroup>

      <FormGroup title="Comments and Photos">
        <NHLECommentsAndPhotosFilter />
      </FormGroup>
    </>
  );
}
